import { deleteApi, get, post } from "../GenericServices";

const ProjectEstimateStatus = {
  getStatusesList: (queryString) => {
    return get(`project-estimate-status?${queryString}`);
  },
  statusData: (id) => {
    return get(`project-estimate-status/${id}`);
  },
  saveStatus: (data) => {
    return post("project-estimate-status", data);
  },
  deleteStatus: (id) => {
    return deleteApi(`project-estimate-status/${id}`);
  },
};

export default ProjectEstimateStatus;
